
export const environment = {
   apiUrl:'https://api.users.mayne.tech/api/',
    //apiUrl:'http://user-management.sketch-creative.com/api/',
    avatar: '/assets/images/avatar_placeholder.png',
    menu: [
        {
            text: 'Sales Orders',
            path: '#',
            key: 'salesorders',
            children: [
                {
                    text: 'Sales Order Entry',
                    subText: 'Add New Order',
                    path: '/sales',
                    active: false,
                    key: 'salesorderentry'
                },
                {
                    text: 'Amend Sales Order',
                    subText: 'Amend a Sales Order',
                    path: '/amendso',
                    active: false,
                    key: 'amendso',
                    type: 'sidebar',
                },
                {
                    text: 'Sales Order Management',
                    subText: 'Manage Sales Orders',
                    path: '/sales/orders',
                    active: false,
                    key: 'salesordermanagement'
                },
                {
                    text: 'Stock Enquiry',
                    subText: 'Make New Enquiry',
                    path: '/stock',
                    active: false,
                    key: 'stockenquiry'
                },
                {
                    text: 'Release Sales Order Lock',
                    subText: 'Release Sales Order Lock',
                    path: '/solock',
                    active: false,
                    key: 'solock',
                    type: 'sidebar',
                },
    
            ],
        },
        {
            icon: '/assets/icons/menu/users.png',
            text: 'User Management',
            subText: 'User Management Area',
            path: '/users',
            includedInWebApp: true,
            active: false,
            children: null,
            key: 'users'
        },
    
    
        {
            icon: '',
            text: 'Locate Stock',
            subText: 'Find stock locations',
            path: 'locate-stock',
            active: false,
            includedInWebApp: false,
            key: 'locatestock',
            children: []
        },
        {
            icon: '',
            text: 'Locate Order',
            subText: 'Find order locations',
            path: 'locate-order',
            active: false,
            includedInWebApp: false,
            key: 'locateorder',
            children: []
        },
        {
            icon: '',
            text: 'Roll/Cut Picking',
            subText: 'Picking operations',
            path: '/picking',
            active: false,
            includedInWebApp: false,
            key: 'rollcutpicking',
            children: [
                {
                    text: 'Roll Picking',
                    subText: 'Roll selection',
                    path: '/picking/roll',
                    active: false,
                    key: 'rollpicking'
                },
                {
                    text: 'Cut Picking',
                    subText: 'Cut selection',
                    path: '/picking/cut',
                    active: false,
                    key: 'cutpicking'
                }
            ]
        },
        {
            icon: '',
            text: 'Roll/Cut Contract Picking',
            subText: 'Contract-based picking',
            path: '/picking/',
            active: false,
            includedInWebApp: false,
            key: 'rollcutcontractpicking',
            children: [
                {
                    text: 'Roll Picking',
                    subText: 'Contract roll selection',
                    path: '/picking/contract-roll',
                    active: false,
                    key: 'contractrollpicking'
                },
                {
                    text: 'Cut Picking',
                    subText: 'Contract cut selection',
                    path: '/picking/contract-cut',
                    active: false,
                    key: 'contractcutpicking'
                }
            ]
        },
        {
            icon: '',
            text: 'VNA/Ground Picking',
            subText: 'Vertical Narrow Aisle picking',
            path: '/picking/vna',
            active: false,
            includedInWebApp: false,
            key: 'vnapicking',
            children: []
        },
        {
            icon: '',
            text: 'Marshall Picking',
            subText: 'Marshall picking operations',
            path: '/picking/marshall',
            active: false,
            includedInWebApp: false,
            key: 'marshallpicking',
            children: []
        },
        {
            icon: '',
            text: 'Goods In Menu',
            subText: 'Receiving goods',
            path: 'goodsin',
            active: false,
            includedInWebApp: false,
            key: 'goodsin',
            children: []
        },
        {
            icon: '',
            text: 'Scanned Loading',
            subText: 'Loading scanned items',
            path: '/scan-loading',
            active: false,
            includedInWebApp: false,
            key: 'scanloading',
            children: []
        },
        {
            icon: '',
            text: 'Bay Check',
            subText: 'Check bay locations',
            path: 'bay-check',
            active: false,
            includedInWebApp: false,
            key: 'baycheck',
            children: []
        },
        {
            icon: '',
            text: 'Trailer Locate',
            subText: 'Locate trailers',
            path: 'trailer-locate',
            active: false,
            includedInWebApp: false,
            key: 'trailerlocate',
            children: []
        },
        {
            icon: '',
            text: 'Stock Take',
            subText: 'Inventory stock count',
            path: 'stock-take',
            active: false,
            includedInWebApp: false,
            key: 'stocktake',
            children: []
        }
    
    
    ]
    
}